function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Evented from '../Evented';
import RequestLoop from './RequestLoop';

var LongPollTransport = /*#__PURE__*/function (_Evented) {
  _inheritsLoose(LongPollTransport, _Evented);

  function LongPollTransport(channelPath, options) {
    var _this;

    _this = _Evented.call(this) || this;
    _this.lastMessageSequence = 0;
    _this.uri = (options.ssl ? 'https' : 'http') + ":" + options.host + channelPath;
    _this.options = options;
    return _this;
  }

  var _proto = LongPollTransport.prototype;

  _proto.start = function start() {
    var _this2 = this;

    this.loop = new RequestLoop(this.uri, this.lastMessageSequence, this.options);
    this.listenTo(this.loop, 'message', function (message, frame) {
      return _this2.emit('message', message, frame);
    });
    this.listenTo(this.loop, 'connected', function (type) {
      return _this2.emit('connected', type);
    });
    this.listenTo(this.loop, 'up', function () {
      return _this2.emit('up');
    });
    this.listenTo(this.loop, 'down', function () {
      return _this2.emit('down');
    });
    this.listenTo(this.loop, 'heartbeat', function () {
      return _this2.emit('heartbeat');
    });
    this.listenTo(this.loop, 'reconnecting', function () {
      return _this2.emit('reconnecting');
    });
    this.listenTo(this.loop, 'failed', function (type, frame) {
      return _this2.emit('failed', type, frame);
    });
  };

  _proto.stop = function stop() {
    if (this.loop) {
      this.lastMessageSequence = this.loop.lastMessageSequence;
      this.loop.stop();
      this.stopListening(this.loop);
      delete this.loop;
    }
  };

  _createClass(LongPollTransport, [{
    key: "didSuccessfullyConnect",
    get: function get() {
      return !!this.loop && this.loop.didSuccessfullyConnect;
    }
  }]);

  return LongPollTransport;
}(Evented);

export { LongPollTransport as default };